import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getSupplierDocumentListData } from './mockData'
import type { ISupplierDocument } from '~/types/document/models'

export const {
  getDocuments: getSupplierDocuments,
  postDocument: postSupplierDocument,
  patchDocument: patchSupplierDocument,
  deleteDocument: deleteSupplierDocument,
  handlers,
} = makeDocumentAPIs<ISupplierDocument>({
  apiPathEntityNamePrefix: 'supplier',
  getDocumentListDataFn: getSupplierDocumentListData,
})
